module.exports = __webpack_public_path__ + "static/media/questionnaire-step2-mobile.89f04d1d.png";